import { useState } from "react";

import {
  IUiConfigButtonAction,
  IUiConfigButtonActionType,
  IUiConfigButtonProps
} from "./types";

import Button from "../../../../../src/components/atomic/Button";
import UiConfigButtonActions, {
  getIconComponent
} from "./UiConfigButtonActions";

const UiConfigButton = ({
  clientSideInput,
  buttonConfig,
  sectionID,
  tabName,
  isLenderDashboard,
  onClickFinished,
  onSuccess,
  styles,
  notifySuccess
}: IUiConfigButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = async (action: IUiConfigButtonAction) => {
    let response;

    switch (action.type) {
      case IUiConfigButtonActionType.API_CALL: {
        response = await UiConfigButtonActions.handleApiCall(
          action.params,
          clientSideInput,
          setIsLoading,
          notifySuccess
        );

        await onClickFinished?.(response, buttonConfig);
        break;
      }
      case IUiConfigButtonActionType.FUNCTION_CALL: {
        response = await UiConfigButtonActions.handleFunctionCall(
          action.params,
          clientSideInput,
          sectionID,
          tabName,
          isLenderDashboard,
          setIsLoading
        );

        await onClickFinished?.(response, buttonConfig);
        break;
      }
      default:
        break;
    }
  };

  return (
    <Button
      key={buttonConfig.key}
      onClick={() => handleButtonClick(buttonConfig?.action)}
      className={styles?.className || "ml-2"}
      color="primary"
      disabled={isLoading}
      size={styles?.size || "default"}
    >
      <div className="flex items-center">
        {getIconComponent(buttonConfig?.icon)}

        <span className={styles?.size === "small" ? "ml-1.5" : "ml-2"}>
          {buttonConfig?.label}
        </span>
      </div>
    </Button>
  );
};

export default UiConfigButton;
